export default __webpack_public_path__ + "static/media/03.89584558.jpg";